import { render, staticRenderFns } from "./dsw.vue?vue&type=template&id=6230fc2a&scoped=true&"
var script = {}
import style0 from "./dsw.vue?vue&type=style&index=0&id=6230fc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230fc2a",
  null
  
)

export default component.exports